<div class="wrapper">
    <app-enterprise-navigation></app-enterprise-navigation>
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>

        <div>
            <section class="add-section width-50">
                <div>
                    <div class="row">
                        <div class="col-md-6 section-heading">Cashbacks Redeemed Breakdown</div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <small>AVAILABLE:</small>
                        </div>
                        <div class="col-md-6">
                            <small>TOTAL CASHBACKS REDEEMED TODAY:</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <span>{{ balance || 0 | currencyFormat }}</span>
                        </div>
                        <div class="col-md-6">
                            <span>{{ cashbacksRedeemedToday || 0 | currencyFormat }}</span>
                        </div>
                    </div>
                </div>
            </section>
            <section class="add-section">
                <form [formGroup]="searchForm">
                    <!-- <div class="row">
                        <div class="col-md-12 section-heading">Search</div>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            <div class="input-icons">
                                <i class="fa fa-search icon" aria-hidden="true"></i>
                                <input
                                    name="text"
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Product, Wholesaler, or Supplier Name"
                                    formControlName="text" />
                                @if (searchForm.get('text').value.length > 0) {
                                    <a (click)="clearText()">
                                        <img src="assets/images/close-x-purple.png" />
                                    </a>
                                }
                            </div>
                        </div>
                        <div class="col-md-7">
                            <button class="search-button" (click)="submit()">Search</button>
                            <a class="advanced-search" (click)="toggleAdvancedSearch()">
                                <img src="assets/images/dropdown.png" />
                                <u>ADVANCED SEARCH</u>
                            </a>
                        </div>
                    </div> -->
                    <!-- @if (showAdvancedSearch) { -->
                    <hr />
                    <div class="search-form">
                        <div class="row">
                            <div class="col-md-4">
                                <label for="fromDateId" class="form-label date-label">
                                    START DATE
                                </label>
                                <div class="datepicker">
                                    <input
                                        id="fromDateId"
                                        matInput
                                        class="datepicker-input"
                                        [min]="minDate"
                                        [max]="maxDate"
                                        [matDatepicker]="picker"
                                        name="fromDate"
                                        formControlName="fromDate"
                                        readonly />
                                    <mat-datepicker-toggle
                                        matSuffix
                                        [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="toDateId" class="form-label date-label">
                                    END DATE
                                </label>
                                <div class="datepicker">
                                    <input
                                        id="toDateId"
                                        matInput
                                        class="datepicker-input"
                                        [min]="searchForm.get('fromDate').value"
                                        [max]="maxDate"
                                        [matDatepicker]="picker1"
                                        name="toDate"
                                        formControlName="toDate"
                                        readonly />
                                    <mat-datepicker-toggle
                                        matSuffix
                                        [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label"></label>
                                <div>
                                    <button class="search-button" (click)="submit()">Search</button>
                                    <a
                                        class="p-3 text-danger line-height-3"
                                        (click)="defaultDates()">
                                        <u>Default Dates</u>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="searched-items">
                        <div *ngFor="let key of searchItems | keyvalue">
                            <div *ngIf="key.value?.length > 0">
                                <div *ngFor="let item of key.value" class="search-item-value">
                                    {{ item | humanize }}
                                    <!-- <a (click)="removeSearchItem(key.key, item)">
                                            <img src="assets/images/close-x-white.png" />
                                        </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- } -->
                </form>
            </section>
        </div>

        @if (showSearchResultRow) {
            <section>
                <div class="container-fluid tab-pane">
                    <br />
                    <div class="row">
                        <div class="col-md-10 section-heading">
                            Search Results: {{ cashbacksRedeemed.length }} of
                            {{ pagination.total }}
                        </div>
                        <div class="col-md-2">
                            <button
                                class="custombtn custombtn-align-right"
                                (click)="getDownloadData()">
                                <i class="fa fa-arrow-up" aria-hidden="true"></i>Export Data
                            </button>
                            <a
                                appExportExcel
                                hidden
                                [data]="excelDataList"
                                fileName="CashbacksRedeemed"
                                id="{{ downloadLinkId }}"
                                class="download-transaction">
                                <u>DOWNLOAD REPORTS</u>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        }

        <hr />

        <div class="container-fluid tab-pane custom-last-row table-scroll">
            <br />

            @if (cashbacksRedeemed?.length > 0) {
                <table class="custom-table table-flexible">
                    <thead>
                        <tr class="form-table-row">
                            <th class="col-customer">
                                <app-filter-arrow
                                    filter="customer"
                                    title="CUSTOMER"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-center">
                                <app-filter-arrow
                                    filter="orderNumber"
                                    title="ORDER NR"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-center">
                                <app-filter-arrow
                                    filter="invoiceNumber"
                                    title="INVOICE NR"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="text-start">
                                <app-filter-arrow
                                    filter="cashier"
                                    title="CASHIER"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-center">
                                <app-filter-arrow
                                    filter="cashierRef"
                                    title="CASHIER REF"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-center">
                                <app-filter-arrow
                                    filter="tillId"
                                    title="TILL"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-center">
                                <app-filter-arrow
                                    filter="sourceSystem"
                                    title="SOURCE"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-date">
                                <app-filter-arrow
                                    filter="createdAt"
                                    title="DATE"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-money">
                                <app-filter-arrow
                                    filter="orderTotalAmount"
                                    title="SALE INCL"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-money">
                                <app-filter-arrow
                                    filter="cashbackAmountRedeemed"
                                    title="CASHBACK REDEEMED"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>

                            <th class="col-money">
                                <app-filter-arrow
                                    filter="runningBalance"
                                    title="RUNNING BALANCE"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        @for (cr of cashbacksRedeemed; track cr?.orderId) {
                            <tr class="form-table-row">
                                <td class="col-customer">
                                    <strong>{{ cr.customer }}</strong>
                                </td>

                                <td class="col-center">
                                    {{ cr.orderNumber }}
                                </td>

                                <td class="col-center">
                                    {{ cr.invoiceNumber }}
                                </td>

                                <td class="text-start">
                                    {{ cr.cashier }}
                                </td>

                                <td class="col-center">
                                    {{ getCashierRefDisplay(cr) }}
                                </td>

                                <td class="col-center">
                                    {{ getTillDisplay(cr) }}
                                </td>

                                <td class="col-center">
                                    {{ cr.sourceSystem || '—' }}
                                </td>

                                <td class="col-date">
                                    {{ cr.createdAt | date: dateTimeFormat }}
                                </td>

                                <td class="col-money">
                                    {{ cr.orderTotalAmount | currency: 'ZAR' : 'symbol-narrow' }}
                                </td>

                                <td class="col-money">
                                    {{
                                        cr.cashbackAmountRedeemed
                                            | currency: 'ZAR' : 'symbol-narrow'
                                    }}
                                </td>

                                <td class="col-money">
                                    {{ cr.runningBalance | currency: 'ZAR' : 'symbol-narrow' }}
                                </td>
                            </tr>
                        }
                    </tbody>

                    <tfoot *ngIf="pagination.showPagination()">
                        <tr>
                            <td>
                                Rows per page:
                                <span>
                                    <b>{{ pagination.length }}</b>
                                </span>
                                <app-page-length-dropdown (emitLength)="changeLength($event)">
                                </app-page-length-dropdown>
                            </td>
                            <td>
                                <app-page-navigation
                                    pageNumber="{{ pagination.getPageNo() }}"
                                    totalPages="{{ pagination.getTotalPages() }}"
                                    (changePage)="changePage($event)">
                                </app-page-navigation>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            } @else {
                <div class="data-empty-wrapper">
                    <div class="data-empty">No data to display</div>
                </div>
            }
        </div>

        <div class="control-sidebar-bg"></div>
    </div>
</div>
